module.exports = __webpack_public_path__ + "img/pitch-white.6c961d7c.svg";